module.exports = __webpack_public_path__ + "static/media/facebook.8b4753a9.svg";